import {
  faAddressBook,
  faClipboard,
  faCookie,
  faFileAlt,
  faFileLines,
  faGear,
  faHome,
  faListCheck,
  faSignOutAlt,
  faThList,
  faTools,
  faUser,
  faUsersGear,
  faVial
} from '@fortawesome/pro-solid-svg-icons';
import { ROUTES } from 'utils/constants/routes';
import { isLaboAdmin } from './roles';

const LABEL_HOME = 'home';
const LABEL_TESTS = 'tests';
//const LABEL_AUDITS = 'audits';
const LABEL_ADMINISTRATION = 'administration';
const LABEL_LABO_ADMIN = 'laboAdmin';
const LABEL_LOGOUT = 'logout';
const LABEL_COOKIES = 'cookies';
const LABEL_MY_PROFILE = 'profile';

const MENU_TABS_LABEL = [LABEL_HOME, LABEL_TESTS, /*LABEL_AUDITS,*/ LABEL_LABO_ADMIN];

export const MENU_TABS_OBJECT = {
  HOME: {
    LABEL: LABEL_HOME,
    ICON: faHome,
    ROUTE: ROUTES.HOME
  },
  TESTS: {
    LABEL: LABEL_TESTS,
    ICON: faVial,
    ROUTE: ROUTES.TESTS
  },
  /*AUDITS: {
    LABEL: LABEL_AUDITS,
    ICON: faBriefcase,
    ROUTE: ROUTES.AUDITS
  },*/
  LABO_ADMIN: {
    LABEL: LABEL_LABO_ADMIN,
    ICON: faGear,
    ROUTE: ROUTES.LABO_ADMIN.GENERAL,
    ROLE_CONDITION: role => isLaboAdmin(role)
  },
  ADMINISTRATION: {
    LABEL: LABEL_ADMINISTRATION,
    ICON: faTools,
    ROUTE: ROUTES.ADMINISTRATION.GENERAL
  },
  LOGOUT: {
    LABEL: LABEL_LOGOUT,
    ICON: faSignOutAlt
  }
};

export const GET_MENU_TABS = () => Object.values(MENU_TABS_OBJECT)
  .filter((tab) => MENU_TABS_LABEL.indexOf(tab.LABEL) !== -1)

const LABEL_LABORATORY_SHEET = 'laboratorySheet';
const LABEL_DOCUMENTS = 'documents';
const LABEL_RESPONSIBILITIES = 'responsibilities';
const LABEL_USERS = 'users';

export const LABO_ADMIN_TABS_OBJECT = {
  LABORATORY_SHEET: {
    LABEL: LABEL_LABORATORY_SHEET,
    ICON: faThList
  },
  DOCUMENTS: {
    LABEL: LABEL_DOCUMENTS,
    ICON: faFileAlt
  },
  RESPONSIBILITIES: {
    LABEL: LABEL_RESPONSIBILITIES,
    ICON: faUsersGear
  },
  USERS: {
    LABEL: LABEL_USERS,
    ICON: faAddressBook
  }
};

export const GET_LABO_ADMIN_TABS = () => Object.values(LABO_ADMIN_TABS_OBJECT);

const LABEL_GENERAL = 'general';

export const ADMINISTRATION_TABS_OBJECT = {
  GENERAL: {
    LABEL: LABEL_GENERAL,
    ICON: faThList
  },
  USERS: {
    LABEL: LABEL_USERS,
    ICON: faAddressBook
  }
};


export const GET_ADMINSTRATION_TABS = () => Object.values(ADMINISTRATION_TABS_OBJECT);

const PT_LABEL_GENERAL = 'general';
const PT_LABEL_MACHINE_INFO = 'machineInformation';
const PT_LABEL_TESTED_POINTS = 'testedPoints';
const PT_LABEL_DOCUMENTS = 'documents';
const PT_LABEL_CONTACT = 'contact';

export const PRODUCT_TEST_TABS_OBJECT = {
  GENERAL: {
    LABEL: PT_LABEL_GENERAL,
    ICON: faThList
  },
  MACHINE_INFORMATION: {
    LABEL: PT_LABEL_MACHINE_INFO,
    ICON: faClipboard
  },
  TESTED_POINTS: {
    LABEL: PT_LABEL_TESTED_POINTS,
    ICON: faListCheck
  },
  DOCUMENTS: {
    LABEL: PT_LABEL_DOCUMENTS,
    ICON: faFileLines
  },
  CONTACT: {
    LABEL: PT_LABEL_CONTACT,
    ICON: faAddressBook
  }
};

export const GET_PRODUCT_TEST_TABS = () => Object.values(PRODUCT_TEST_TABS_OBJECT);

export const getTabsByPage = pageName => {
  switch (pageName) {
  case 'tests':
    return GET_PRODUCT_TEST_TABS
  case 'administration':
    return GET_ADMINSTRATION_TABS
  case 'laboAdmin':
    return GET_LABO_ADMIN_TABS
  default:
    return () => ([]);
  }
}

export const GENERAL_ACCOUNT_TABS_OBJECT = {
  PROFILE: {
    LABEL: LABEL_MY_PROFILE,
    ICON: faUser,
    ROUTE: ROUTES.GENERAL_ACCOUNT.PROFILE,
    DISABLED: true
  },
  COOKIES: {
    LABEL: LABEL_COOKIES,
    ICON: faCookie,
    ROUTE: ROUTES.GENERAL_ACCOUNT.COOKIES
  }
}

export const ACCOUNT_TABS_OBJECT = {
  PROFILE: {
    LABEL: LABEL_MY_PROFILE,
    ICON: faUser,
    ROUTE: ROUTES.ACCOUNT.PROFILE
  },
  COOKIES: {
    LABEL: LABEL_COOKIES,
    ICON: faCookie,
    ROUTE: ROUTES.ACCOUNT.COOKIES
  }
}

export const GET_ACCOUNT_TABS = (general = false) => {
  return general ? Object.values(GENERAL_ACCOUNT_TABS_OBJECT) : Object.values(ACCOUNT_TABS_OBJECT);
}